import {Button} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"

function SelectQuestion({question, answers, onAnswer}) {
	return (
		<ButtonsGrid container direction="column" alignItems="stretch" spacing={5}>
			{question.Options.map((option) => (
				<Grid key={option.Label}>
					<Button
						fullWidth
						variant="outlined"
						onClick={() =>
							onAnswer(option, [
								...answers,
								{QuestionNumber: question.Number, OptionNumber: option.Number},
							])
						}
					>
						{option.Label}
					</Button>
				</Grid>
			))}
		</ButtonsGrid>
	)
}

const ButtonsGrid = styled(Grid)`
	margin-top: 20px;
	flex: 1;
`

export {SelectQuestion}
